export default "__VITE_ASSET__3217b938__"